import React from 'react';

import { UiButton } from '@shared/ui';

import cls from './FilePreviewer.module.css';

interface IPreviewerArrowProps {
    arrowType: 'next' | 'prev';
    isFirst: boolean;
    isLast: boolean;
    goPrevHandler?: () => void;
    goNextHandler?: () => void;
}

export const PreviewerArrow = ({
    arrowType,
    isFirst,
    isLast,
    goPrevHandler,
    goNextHandler,
}: IPreviewerArrowProps) => {
    if (arrowType === 'prev') {
        return (
            <div className={cls.prevFileArrow} onClick={(event) => event.stopPropagation()}>
                {!isFirst && (
                    <UiButton
                        onClick={goPrevHandler}
                        variant="icon"
                        startIcon={
                            <svg
                                width="50"
                                height="50"
                                viewBox="0 0 50 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="50"
                                    height="50"
                                    rx="25"
                                    fill="#757575"
                                    fillOpacity="0.25"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M28.3535 18.6465C28.5488 18.8417 28.5488 19.1583 28.3535 19.3536L22.7071 25L28.3535 30.6464C28.5488 30.8417 28.5488 31.1583 28.3535 31.3536C28.1583 31.5488 27.8417 31.5488 27.6464 31.3536L21.6464 25.3536C21.4512 25.1583 21.4512 24.8417 21.6464 24.6464L27.6464 18.6465C27.8417 18.4512 28.1583 18.4512 28.3535 18.6465Z"
                                    fill="#F5F5F5"
                                />
                            </svg>
                        }
                    />
                )}
            </div>
        );
    }
    if (arrowType === 'next') {
        return (
            <div className={cls.nextFileArrow} onClick={(event) => event.stopPropagation()}>
                {!isLast && (
                    <UiButton
                        className=""
                        onClick={goNextHandler}
                        variant="icon"
                        startIcon={
                            <svg
                                width="50"
                                height="50"
                                viewBox="0 0 50 50"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect
                                    width="50"
                                    height="50"
                                    rx="25"
                                    fill="#757575"
                                    fillOpacity="0.25"
                                />
                                <path
                                    fillRule="evenodd"
                                    clipRule="evenodd"
                                    d="M21.6465 31.3535C21.4512 31.1583 21.4512 30.8417 21.6465 30.6464L27.2929 25L21.6465 19.3536C21.4512 19.1583 21.4512 18.8417 21.6465 18.6464C21.8417 18.4512 22.1583 18.4512 22.3536 18.6464L28.3536 24.6464C28.5488 24.8417 28.5488 25.1583 28.3536 25.3536L22.3536 31.3535C22.1583 31.5488 21.8417 31.5488 21.6465 31.3535Z"
                                    fill="#F5F5F5"
                                />
                            </svg>
                        }
                    />
                )}
            </div>
        );
    }
};
